// extracted by mini-css-extract-plugin
export var compactFilters = "_d8-4";
export var detailImage = "_d8-1";
export var dropdownContainer = "_d8-2";
export var imageContainer = "_d8-0";
export var selectedCard = "_d8-3";